import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { RESET_STATE_ACTION } from '../types';
import { createSlice } from '../utils';

import { FiberWaitListState, initialFiberWaitListState } from './types';
import { validateName, validateEmail, validatePhone } from './validation';
import { Country } from '@buy-viasat/types/build/bv';

const fiberWaitListSlice = createSlice({
  name: 'fiberWaitList',
  initialState: initialFiberWaitListState,
  reducers: {
    // Placeholder for future async actions (e.g., submission)
    applyForFiberWaitlist(): void {},
    // SETTERS START
    setFirstName(state: FiberWaitListState, action: PayloadAction<string>): void {
      state.firstName.value = action.payload;
      state.firstName.valid = validateName(action.payload);
    },
    setLastName(state: FiberWaitListState, action: PayloadAction<string>): void {
      state.lastName.value = action.payload;
      state.lastName.valid = validateName(action.payload);
    },
    setEmail(state: FiberWaitListState, action: PayloadAction<string>): void {
      state.email.value = action.payload;
      state.email.valid = validateEmail(action.payload);
    },
    setPhone(state: FiberWaitListState, action: PayloadAction<string | { value: string; country?: Country }>): void {
      if (typeof action.payload === 'string') {
        state.phone.value = action.payload;
        state.phone.valid = validatePhone(action.payload);
      } else {
        state.phone.value = action.payload.value;
        state.phone.valid = validatePhone(action.payload.value);
      }
    },
    setIsWaitlistLoading(state: FiberWaitListState, action: PayloadAction<boolean>): void {
      state.isWaitlistLoading = action.payload;
    },
    setIsWaitlistRequestComplete(state: FiberWaitListState, action: PayloadAction<boolean>): void {
      state.isWaitlistRequestComplete = action.payload;
    },
    resetForm: () => initialFiberWaitListState,
    resetFormFields(state: FiberWaitListState): FiberWaitListState {
      return {
        ...state,
        firstName: { value: '', valid: null, hintText: 'First name is required' },
        lastName: { value: '', valid: null, hintText: 'Last name is required' },
        email: { value: '', valid: null, hintText: 'Email is required' },
        phone: { value: '', valid: null, hintText: 'Phone number format invalid' },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetState, (): FiberWaitListState => initialFiberWaitListState);
  },
});

const resetState = createAction(RESET_STATE_ACTION.type);

export const {
  actions: fiberWaitListActions,
  reducer: fiberWaitListReducer,
  name: fiberWaitListKey,
} = fiberWaitListSlice;
